import { TextField } from '@material-ui/core';
import DraftsIcon from '@material-ui/icons/Drafts';
import React, { useEffect, useState } from 'react';

import {
  IMonitorNotificationProviderBaseClass,
  IMonitorNotificationProviderBaseClassProps,
} from '~/src/dash/components/monitor/monitor_notifications/notifier';
import { DEMO_ACCOUNTS } from '~/src/dash/globals/constants';
import { IStore } from '~/src/dash/reducers/store';
import { IUserStateProps } from '~/src/dash/types/props';
import { decorate } from '~/src/dash/utils/decorator';

export interface IMonitorNotifierEmailData {
  recipients: string;
}

export interface IMonitorNotifierEmailDataForHistory {
  recipients: string;
}

interface IProps extends IMonitorNotificationProviderBaseClassProps, IUserStateProps {}

function _MonitorNotifierURLComponent(props: IProps) {
  const data = (props.notifier.Data as IMonitorNotifierEmailData) || {};

  const [recipients, setRecipients] = useState(data.recipients || '');

  useEffect(() => {
    props.onUpdateData(createData());
  }, [recipients]);

  const createData = function (): IMonitorNotifierEmailData {
    // build data
    return {
      recipients,
    };
  };

  return (
    <TextField
      id='notifier-url-textfield'
      label='Recipients (comma separated)'
      variant='standard'
      onChange={({ target }: React.ChangeEvent<HTMLInputElement>) => {
        setRecipients(target.value);
      }}
      value={DEMO_ACCOUNTS.includes(props.user.user.Username) ? 'username@email.com' : recipients}
      fullWidth
    />
  );
}

export const MonitorNotifierURLComponent = decorate(
  {
    redux: (state: IStore) => {
      return {
        user: state.user,
        session: state.session,
      };
    },
    router: true,
  },
  _MonitorNotifierURLComponent,
);

export class MonitorNotifierEmail implements IMonitorNotificationProviderBaseClass {
  returnData: (data: any) => void = undefined as any;

  Logo = (<DraftsIcon style={{ fontSize: 40 }} />);
  Render = (notifier: any) => (
    <MonitorNotifierURLComponent
      notifier={notifier}
      onUpdateData={(data: any) => {
        if (this.returnData !== undefined) {
          this.returnData(data);
        }
      }}
    />
  );

  SetReturnData(cb: (data: any) => void) {
    this.returnData = cb;
  }

  Validate(notifier: any): string {
    if (notifier === undefined) {
      return 'invalid notification';
    }
    const data = (notifier.Data as IMonitorNotifierEmailData) || {};
    if (data.recipients === undefined || data.recipients === '') {
      return 'no recipients selected';
    }
    return '';
  }

  IsSuperAdminOnly(): boolean {
    return false;
  }
}
